var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg246462018Fb1Fdde4D60E0869A01238D(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127.699,
    height: 127.699,
    viewBox: "0 0 127.699 127.699",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_246462018fb1fdde4d60e0869a01238d",
    "data-name": "246462018fb1fdde4d60e0869a01238d",
    d: "M48.741,2A46.741,46.741,0,1,0,95.482,48.741,46.739,46.739,0,0,0,48.741,2ZM61.829,64.973A3.193,3.193,0,0,1,57,67.718L29.734,51.486a3.193,3.193,0,0,1,0-5.486L57,29.768a3.19,3.19,0,0,1,4.824,2.741Z",
    transform: "translate(81.69 -2.732) rotate(60)",
    fill: "#e53935"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg246462018Fb1Fdde4D60E0869A01238D);
export default __webpack_public_path__ + "static/media/246462018fb1fdde4d60e0869a01238d.f51cda8505366ffed34f42381248641e.svg";
export { ForwardRef as ReactComponent };